// extracted by mini-css-extract-plugin
export default {"wrapper":"ActionBox_wrapper__rcEAO","title":"ActionBox_title__IMHQp","subtitle":"ActionBox_subtitle__aQutI","content":"ActionBox_content__1sxpr","actions":"ActionBox_actions__vzNWs"};